import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { adminService } from '@/services/admin';
import { Card } from '@/components/ui/Card';
import { resolvePersonPhoto } from '@/utils/avatars';

export function WorstTeachersWidget() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ['teacher-rankings', 'worst'],
    queryFn: () => adminService.getTeacherRankings('worst', 5, 'monthly'),
  });

  if (isLoading) return <div className="h-64 animate-pulse rounded-xl bg-slate-50" />;

  return (
    <Card className="p-6">
      <div className="mb-6">
        <h3 className="text-lg font-bold text-slate-800">Lowest attendance</h3>
        <p className="text-sm text-slate-500">Who is away this month</p>
      </div>
      <div className="space-y-4">
        {data?.map((teacher) => (
          <button
            key={teacher.id}
            type="button"
            onClick={() => navigate(`/admin/reports/teachers/${teacher.id}`)}
            className="flex w-full items-center gap-4 rounded-lg border border-slate-100 bg-slate-50 p-3 text-left hover:border-slate-200"
          >
            <div className="h-10 w-10 flex-shrink-0 overflow-hidden rounded-full border-2 border-white bg-slate-100 shadow-sm">
              <img src={resolvePersonPhoto(teacher, 'teacher')} alt="" className="h-full w-full object-cover" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="truncate font-semibold text-slate-900">{teacher.name}</div>
              <div className="text-xs text-slate-500">Staff</div>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold text-slate-800">{teacher.attendanceRate}%</div>
              <div className="text-xs font-medium text-slate-500">{teacher.totalAbsent} Absences</div>
            </div>
          </button>
        ))}
        {(!data || data.length === 0) && <div className="py-4 text-center text-slate-400">No attendance recorded yet</div>}
      </div>
    </Card>
  );
}
